import { render, staticRenderFns } from "./KZFrame.vue?vue&type=template&id=742c9c68&scoped=true&"
import script from "./KZFrame.vue?vue&type=script&lang=js&"
export * from "./KZFrame.vue?vue&type=script&lang=js&"
import style0 from "./KZFrame.vue?vue&type=style&index=0&id=742c9c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c9c68",
  null
  
)

export default component.exports